import React from 'react';
import MarkdownPreviewer from './components/MarkdownPreviewer';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <MarkdownPreviewer />
    </div>
  );
}

export default App;
